// extracted by mini-css-extract-plugin
module.exports = {"container":"A7-IXNyNq6UDaYyVmjdlN"};